import React, { useState, useEffect } from "react";
import "./style.css";
import ContentLoader from "react-content-loader";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay, Pagination } from "swiper/modules";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PortFolioData = () => {
  // ALL STATES
  const [showAll, setShowAll] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [showDetailCard, setshowDetailCard] = useState(false);
  const [loading, setLoading] = useState(true);
  // ALL STATES
  
  const { t } = useTranslation("portfolio");
  const [activeCategory, setActiveCategory] = useState(t("all"));

  // Get translated projects array
  const projects = t("projects", { returnObjects: true });

  // Extract unique categories
  const categories = [t("all"), ...new Set(projects.map((item) => item.category))];

  const filteredProjects =
    activeCategory === t("all")
      ? projects
      : projects.filter((item) => item.category === activeCategory);

  const visibleProjects = showAll
    ? filteredProjects
    : filteredProjects.slice(0, 6);

  // SCALTON LOADING ON DETAILS
  useEffect(() => {
    if (showDetailCard) {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 1500);
    }
  }, [showDetailCard, selectedProject]);

  // SHOW DETAILS FUNCTIONS
  const showDetails = (id) => {
    setshowDetailCard(true);
    const project = visibleProjects.find((item) => item.id === id);
    console.log("project =>", project);
    setSelectedProject(project);
  };

  const handleGtmClick = (obj) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "portfolio_project_card_click",
      project_portfolio_card_id: obj.id,
      project_portfolio_card_title: obj.title,
      project_portfolio_card_description: obj.description,
      project_portfolio_card_image: obj.image,
    });
  };

  return (
    <>
      <div className="portfolio-main-box">
        <div className="container">
          <div className="row" style={{ transition: "all 0.3s ease-in-out" }}>
            <div className="col-md-12">
              <h1 className="main-heading">{t("heading")}</h1>
              <h3 className="sub-heading">{t("subHeading")}</h3>
            </div>

            <div className="col-md-12">
              <div className="links-boxes mb-5">
                <ul className="links-boxes-lists">
                  {categories.map((category, index) => (
                    <li
                      id="portfolio-category-tab-title"
                      key={index}
                      className={`category-tab ${activeCategory === category ? "active" : ""
                        }`}
                      onClick={() => setActiveCategory(category)}
                    >
                      {category}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {showDetailCard ? (
              <div
                className="col-lg-4 col-md-5 col-xl-4"
                style={{ transition: "all 0.3s ease-in-out" }}
              >
                {visibleProjects.map((card, index) => (
                  <div
                    className="col-lg-12 col-md-12 col-xl-12 mb-4"
                    key={index}
                  >
                    <div
                      className={`project-card-main ${selectedProject?.id === card.id
                        ? "active-detail-card"
                        : ""
                        }`}
                    >
                      <div className="project-image">
                        <img src={card.image} alt={card.title} />
                      </div>
                      <h2>{card.title}</h2>
                      <p className="common-text">
                        {card?.description?.split(" ").slice(0, 20).join(" ")}
                        ...
                      </p>
                      <div className="project-button">
                        <a
                          className="common-green-btn details-btn portfolio-project-card-title"
                          onClick={() => {
                            showDetails(card.id);
                            handleGtmClick(card);
                          }}
                        >
                          {t("seeDetails")}{" "}
                          <i
                            className={`fa-solid ${document.dir === "rtl"
                              ? "fa-arrow-left"
                              : "fa-arrow-right"
                              }`}
                          ></i>
                        </a>
                      </div>
                    </div>
                  </div>
                ))}

                {filteredProjects.length > 6 && (
                  <div className="mt-4 view-all-button">
                    <span onClick={() => setShowAll((prev) => !prev)}>
                      {showAll ? t("loadLess") : t("loadMore")}
                    </span>
                  </div>
                )}
              </div>
            ) : (
              <>
                {visibleProjects.map((card, index) => (
                  <div
                    className="col-lg-4 col-md-6 col-xl-4 mb-4"
                    key={index}
                    style={{ transition: "all 0.3s ease-in-out" }}
                  >
                    <div className="project-card-main">
                      <div className="project-image">
                        <img src={card.image} alt={card.title} />
                      </div>
                      <h2>{card.title}</h2>
                      <p className="common-text">
                        {card?.description?.split(" ")?.slice(0, 20)?.join(" ")}
                        ...
                      </p>
                      <div className="project-button">
                        <a
                          className="common-green-btn details-btn portfolio-project-card-title"
                          onClick={() => {
                            showDetails(card.id);
                            handleGtmClick(card);
                          }}
                        >
                          {t("seeDetails")}{" "}
                          <i
                            className={`fa-solid ${document.dir === "rtl"
                              ? "fa-arrow-left"
                              : "fa-arrow-right"
                              }`}
                          ></i>
                        </a>
                      </div>
                    </div>
                  </div>
                ))}

                {filteredProjects.length > 6 && (
                  <div className="mt-4 view-all-button">
                    <span onClick={() => setShowAll((prev) => !prev)}>
                      {showAll ? t("loadLess") : t("loadMore")}
                    </span>
                  </div>
                )}
              </>
            )}

            {showDetailCard && (
              <div
                className="col-lg-8 col-md-7 col-xl-8"
                style={{ transition: "all 0.3s ease-in-out" }}
              >
                <div className="project-details-box">
                  {loading ? (
                    <ContentLoader
                      speed={1}
                      width={`100%`}
                      height={`100%`}
                      viewBox="0 0 800 400"
                      backgroundColor="#6969692a"
                      foregroundColor="#ffffff29"
                    >
                      <rect
                        x="0"
                        y="0"
                        rx="5"
                        ry="5"
                        width="800"
                        height="200"
                      />
                      <rect
                        x="0"
                        y="220"
                        rx="4"
                        ry="4"
                        width="400"
                        height="30"
                      />
                      <rect
                        x="0"
                        y="270"
                        rx="4"
                        ry="4"
                        width="700"
                        height="20"
                      />
                      <rect
                        x="0"
                        y="300"
                        rx="4"
                        ry="4"
                        width="650"
                        height="20"
                      />
                    </ContentLoader>
                  ) : (
                    <>
                      <div className="project-image-main">
                        <Swiper
                          slidesPerView={"1"}
                          spaceBetween={30}
                          navigation={false}
                          autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                          }}
                          pagination={{
                            clickable: true,
                          }}
                          modules={[Navigation, Autoplay, Pagination]}
                          className="mySwiper project-detials-card"
                        >
                          <SwiperSlide>
                            <img
                              src={selectedProject?.image}
                              alt={`${selectedProject?.image}`}
                            />
                          </SwiperSlide>

                          <SwiperSlide>
                            <img
                              src={selectedProject?.image2}
                              alt={`${selectedProject?.image2}`}
                            />
                          </SwiperSlide>

                          <SwiperSlide>
                            <img
                              src={selectedProject?.image3}
                              alt={`${selectedProject?.image3}`}
                            />
                          </SwiperSlide>
                        </Swiper>

                        <span
                          onClick={() => setshowDetailCard(false)}
                          className="cross-detail-button"
                        >
                          <i className="fa-solid fa-xmark"></i>
                        </span>
                      </div>

                      <h2>{selectedProject?.title}</h2>
                      <p className="common-text">
                        {selectedProject?.description}
                      </p>

                      {/* <div className="project-detail">
                        <h2>{selectedProject?.projectTitle}</h2>

                        <p className="common-text">
                          {selectedProject?.overview}
                        </p>


                        <h3 className="my-2">Tech Stack Used:</h3>

                        <ul>
                          <li>
                            <strong>Frontend:</strong>{" "}
                            {selectedProject?.techStackUsed?.frontend?.join(
                              ", "
                            )}
                          </li>
                          <li>
                            <strong>Backend:</strong>{" "}
                            {selectedProject?.techStackUsed?.backend?.join(
                              ", "
                            )}
                          </li>
                          <li>
                            <strong>Integrations:</strong>{" "}
                            {selectedProject?.techStackUsed?.integrations?.join(
                              ", "
                            )}
                          </li>
                          <li>
                            <strong>Performance Tools:</strong>{" "}
                            {selectedProject?.techStackUsed?.performanceTools?.join(
                              ", "
                            )}
                          </li>
                          <li>
                            <strong>A/B Testing:</strong>{" "}
                            {selectedProject?.techStackUsed?.abTesting?.join(
                              ", "
                            )}
                          </li>
                        </ul>

                        <h3>Challenges:</h3>
                        {selectedProject?.challenges?.map(
                          (challenge, index) => (
                            <div key={index}>
                              <h4 className="my-2">{challenge?.title}</h4>
                              <p className="common-text">
                                {challenge?.description}
                              </p>
                            </div>
                          )
                        )}

                        <h3 className="my-3">
                          Solutions by Bitsclan IT Solutions:
                        </h3>
                        {selectedProject?.solutionsByBitsclanITSolutions?.map(
                          (solution, index) => (
                            <div key={index}>
                              <h4 className="my-2">{solution?.title}</h4>
                              <ul>
                                {solution?.actions?.map((action, idx) => (
                                  <li key={idx}>{action}</li>
                                ))}
                              </ul>
                              <p className="common-text">
                                <strong>Outcome:</strong> {solution.outcome}
                              </p>
                            </div>
                          )
                        )}

                        <h3 className="my-3">Results Achieved:</h3>
                        <table
                          style={{ width: "100%", borderCollapse: "collapse" }}
                        >
                          <thead>
                            <tr>
                              <th
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "left",
                                }}
                              >
                                Area
                              </th>
                              <th
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "left",
                                }}
                              >
                                Achievement
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {selectedProject?.resultsAchieved?.map(
                              (result, index) => (
                                <tr key={index}>
                                  <td
                                    style={{
                                      border: "1px solid #ddd",
                                      padding: "8px",
                                    }}
                                  >
                                    {result.area}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #ddd",
                                      padding: "8px",
                                    }}
                                  >
                                    {result.achievement}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>

                        <h3 className="my-3">Conclusion:</h3>
                        <p className="common-text">
                          {selectedProject?.conclusion}
                        </p>
                      </div> */}

                      <div className="header-link-green mt-4">
                        <a
                          className="space-left-remove"
                          href="https://calendly.com/bitsclan-it/30min?month=2025-01"
                          target="_blank"
                        >
                          {t("scheduleACall")}
                        </a>
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PortFolioData;
